import {
	createStyles,
	Theme,
	Typography,
	WithStyles,
	withStyles,
} from '@material-ui/core'
import imageCompression from "browser-image-compression";
import React, { Component,useEffect } from 'react'
import DocSubmitButton from 'src/components/Templates/FileUpload/DocSubmitButton';
import FilePreview from 'src/components/Templates/FileUpload/FilePreview';
import { connect, ConnectedProps  } from "react-redux";
import {updateCredentialDoc,genericAction} from '../../features/pacticipantOutcomeSlice'
import { convertFileToBase64 } from 'src/services/utils';

interface FileUploadFormState {
	fileSizeWarning: boolean
	fileTypeWarning: boolean
  credentialDoc: File | null,
  error: string| null
}

const mapStateToProps = (state:any) => ({
  credentialDoc1: state.participantOutcome.credentialDoc1,
  credentialDoc2: state.participantOutcome.credentialDoc2,
  credentialDoc1Uploaded: state.participantOutcome.credentialDoc1Uploaded,
  credentialDoc2Uploaded: state.participantOutcome.credentialDoc2Uploaded,
  credential1Error: state.participantOutcome.credential1Error,
  credential2Error: state.participantOutcome.credential2Error,
  external_id: state.participantOutcome.external_id
});

const mapDispatchToProps = { updateCredentialDoc, genericAction };

const connector = connect(
  mapStateToProps,
  mapDispatchToProps
)

type PropsFromRedux = ConnectedProps<typeof connector>

interface FileUploadFormProps extends WithStyles<typeof styles>, PropsFromRedux {
  index: number
}

export class FileUploadForm extends Component<FileUploadFormProps, FileUploadFormState> {

	public readonly state: FileUploadFormState = {
	  fileSizeWarning: false,
	  fileTypeWarning: false,
    credentialDoc: null,
    error:null
	}

	private formRef: React.RefObject<HTMLFormElement> = React.createRef()
	private fileInputRef: React.RefObject<HTMLFormElement> = React.createRef()
	// private idTypeRef: React.RefObject<HTMLFormElement> = React.createRef()

	validate = () => {
		const form = this.formRef.current
		return form && form.reportValidity()
	}

	handleIdTypeChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		
	}

	handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()

		
	}

  componentDidUpdate(prevProps: Readonly<FileUploadFormProps>, prevState: Readonly<FileUploadFormState>, snapshot?: any): void {
    if(!this.props[`credentialDoc${this.props.index}`] && prevProps[`credentialDoc${this.props.index}`]){
      this.setState({
        fileSizeWarning: false,
        fileTypeWarning: false,
        credentialDoc: null
      })
    }
    if(this.props[`credential${this.props.index}Error`] !== prevProps[`credential${this.props.index}Error`]){
      this.setState((prevState)=>{
        return {
          ...prevState,
          error: this.props[`credential${this.props.index}Error`]
        }
      })
    }
  }


	onIdDoc = async (e: React.FormEvent<HTMLDivElement>) => {
    const uploadFile = this.fileInputRef
    this.props.genericAction({[`credential${this.props.index}Error`]:null})
    if (uploadFile?.current?.files) {
      let uploadedFile = uploadFile.current.files[0];
      let fileSizeCheck = uploadedFile.size < 10000000;
      const fileTypeCheck = /^image\/.*|.pdf$/.test(uploadedFile.type);
      const imageTypeCheck = /^image\/(jpeg|jpg|png|bmp|tiff)$/.test(uploadedFile.type);

      if (!fileSizeCheck && imageTypeCheck) {
        const options = {
          maxSizeMB: 10
        }
        try {
          const compressedFile = await imageCompression(uploadedFile, options);
          uploadedFile = compressedFile
          fileSizeCheck = uploadedFile.size < 10000000

        } catch (error) {
          console.log(error);
        }
      }

      if (fileSizeCheck && fileTypeCheck) {

        this.setState({
          fileSizeWarning: false,
          fileTypeWarning: false,
          credentialDoc: uploadedFile
        })
        let encodedFile = await convertFileToBase64(uploadedFile)
        console.log(encodedFile)
        encodedFile = encodedFile.split(',')[1]
        const payload = {
          [`credentialDoc${this.props.index}`]:encodedFile,
          [`credentialDoc${this.props.index}FileName`]: uploadedFile.name,
          [`credentialDoc${this.props.index}FileExt`]:uploadedFile.name.substring(uploadedFile.name.lastIndexOf('.'))
        }
        this.props.genericAction(payload)
        // this.props.updateCredentialDoc(encodedFile)
      } else if (!fileSizeCheck) {
        this.setState({
          fileSizeWarning: true,
        })
      } else if (!fileTypeCheck) {
        this.setState({
          fileTypeWarning: true,
        })
      }
    }
  }

	handleFileUpload = () => {
		if (this.fileInputRef && this.fileInputRef.current) {
			this.fileInputRef.current.click()
		}
	}

	handleFileRemove = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
		e.preventDefault()
		this.setState({
			fileSizeWarning: false,
			fileTypeWarning: false,
      credentialDoc: null
		})
    this.props.genericAction({
      [`credentialDoc${this.props.index}`]:null,
      [`credentialDoc${this.props.index}FileName`]:null,
      [`credentialDoc${this.props.index}FileExt`]:null
    })
	}

  renderWarning(message: string) {
    return (
      <Typography variant="h6" color="error">
        {message}
      </Typography>
    )
  }

  render() {
    const {classes } = this.props
    // const { idDoc, idType } = participant
    const { fileSizeWarning, fileTypeWarning, credentialDoc } = this.state

		return (
			<form onSubmit={this.handleSubmit} className={classes.root} ref={this.formRef}>
				<div className={classes.formItemsWrapper}>
					<Typography variant="h6"> Upload documentation of your credential/certificate</Typography>
					<Typography variant="h6"> Documentation can be:</Typography>
          <ul>
            <li>.jpeg (preferred)</li>
            <li>.jpg (preferred)</li>
            <li>.png (preferred)</li>
            <li>.bmp</li>
            <li>.pdf</li>
            <li>.tiff</li>
          </ul>
          <div className={classes.idDocSubmit}>
            {
              credentialDoc ?
                <FilePreview docName={credentialDoc.name} handleFileRemove={this.handleFileRemove} >
                </FilePreview> :
                <DocSubmitButton disabled={!this.props.external_id} onChange={this.onIdDoc} onUpload={this.handleFileUpload} inputRef={this.fileInputRef} />
            }
          </div>

          {(!this.props.external_id && <Typography variant="h6" className={classes.warn}>
            User does not have an external Id, so credential document cannot be uploaded
          </Typography>) }

          {this.renderError()}

          {fileSizeWarning && this.renderWarning("warn")}

          {fileTypeWarning && this.renderWarning("warn")}

          {/* <IDInfo /> */}
				</div>
			</form>
		)
	}

  componentWillUnmount(){
    this.props.updateCredentialDoc(null)
  }

  renderError(){
    if(this.props[`credential${this.props.index}Error`]){
      return (<Typography variant="h6" color="error">
        {this.props[`credential${this.props.index}Error`]}
      </Typography>)
    }
  }
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
			alignSelf: 'center',
			justifySelf: 'center',
			padding: `${theme.spacing.unit * 2}px 0`,
			margin: '0 auto',

			[theme.breakpoints.up('lg')]: {
				width: '50%',
			},

			[theme.breakpoints.only('md')]: {
				width: '60%',
			},
			[theme.breakpoints.only('sm')]: {
				width: '75%',
			},
			[theme.breakpoints.only('xs')]: {
				width: '90%',
			},
		},
		icon: {},
		buttonContainer: {
			display: 'flex',
			justifyContent: 'flex-end',
		},
		button: {
			marginLeft: `${theme.spacing.unit * 2}px`,
		},
    formItemsWrapper: {},
    idDocRow: {},
    idDocSubmit: {},
    warn:{
      color: 'orange',
      fontSize: '1rem'
    }
	})



export default connector(withStyles(styles)(FileUploadForm))
